<div class="container">
    <div class="row mt-4">
        <ng-container *ngFor="let social of socialLinks">
            <div class="col-md-12 mt-4">
                <a href="{{social.link}}" target="_blank">
                    <img src="{{social.image}}" alt="{{social.name}}">
                    <span style="padding-left: 15px;">{{social.displayName}}</span>
                </a>
            </div>
        </ng-container>
    </div>
</div>